import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getCategoryCount } from "@/utils/news";

export default function CategoryQuickLinks() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {categories.map((category) => (
        <Link
          key={category.id}
          to={`/category/${category.id}`}
          className="group flex items-center gap-3 p-3.5 md:p-4 bg-background-50 border border-background-200 rounded-lg hover:border-primary-300 transition-colors cursor-pointer"
        >
          <span className="w-10 h-10 md:w-11 md:h-11 shrink-0 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center">
            <i className={`${category.icon} text-lg md:text-xl`} />
          </span>
          <span className="min-w-0">
            <span className="block text-sm md:text-[15px] font-medium text-foreground-900 group-hover:text-primary-600 transition-colors">
              {category.name}
            </span>
            <span className="block mt-0.5 text-[11px] md:text-xs text-foreground-500">
              {getCategoryCount(category.id)} 篇资讯
            </span>
          </span>
        </Link>
      ))}

      <Link
        to="/topic/topic-drama-2026"
        className="group flex items-center gap-3 p-3.5 md:p-4 bg-primary-950 border border-primary-950 rounded-lg hover:bg-primary-900 transition-colors cursor-pointer"
      >
        <span className="w-10 h-10 md:w-11 md:h-11 shrink-0 rounded-md bg-accent-500/20 text-accent-300 flex items-center justify-center">
          <i className="ri-bookmark-3-line text-lg md:text-xl" />
        </span>
        <span className="min-w-0">
          <span className="block text-sm md:text-[15px] font-medium text-background-50">热门专题</span>
          <span className="block mt-0.5 text-[11px] md:text-xs text-background-400">4 个深度合集</span>
        </span>
      </Link>
    </div>
  );
}